import { render, staticRenderFns } from "./ActivityItemNote.vue?vue&type=template&id=644e97f8&scoped=true&"
import script from "./ActivityItemNote.vue?vue&type=script&lang=js&"
export * from "./ActivityItemNote.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemNote.vue?vue&type=style&index=0&id=644e97f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e97f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644e97f8')) {
      api.createRecord('644e97f8', component.options)
    } else {
      api.reload('644e97f8', component.options)
    }
    module.hot.accept("./ActivityItemNote.vue?vue&type=template&id=644e97f8&scoped=true&", function () {
      api.rerender('644e97f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityItemNote.vue"
export default component.exports